import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { CostCentre } from 'src/types/CostCentre'
import { costCentresAdapter } from '../adapters/costCentres'

export const initialState = costCentresAdapter.getInitialState()

export const { reducer, actions } = createSlice({
  name: 'costCentres',
  initialState,
  reducers: {
    addMultipleCostCentres: (state, action: PayloadAction<CostCentre[]>) => {
      costCentresAdapter.upsertMany(state, action.payload)
    },
    replaceAllCostCentres: (state, action: PayloadAction<CostCentre[]>) => {
      costCentresAdapter.setAll(state, action.payload)
    },

  },
})

export const { addMultipleCostCentres, replaceAllCostCentres } = actions
